import { EnvironmentInterface } from '../app/core/models/environment.interface';

export const environment: EnvironmentInterface = {
    production: true,
    providers: [],
    macBackendUrl: ''
};
